<template>
  <div class="main-page ">
    <Menu title="法律法规查询"
          :border="true">
      <template slot="right-link">
        <div class="servicePoint"></div>
      </template>
    </Menu>
    <div class="container-flex main">
      <div class="left">
        <div class="maincon">
          <div class="voice-consult"
               v-if="type == 1">
            <div class="voice"></div>
            <div class="title">
              请点击上面图标
            </div>
            <div class="desc">
              使用普通话说出你想要搜索的法律法规
            </div>
          </div>
          <div class="search-input "
               v-if="type == 2">
            <div class="title">
              法律法规查询
            </div>
            <div class="search-box">
              <input type="text"
                     v-model="searchText"
                     @keyup.enter="getSearchResult"
                     placeholder="请输入需要查询的法规关键字" />
              <button @click="getSearchResult">搜索</button>
            </div>
            <div class="ht-info">
              <span v-for="(item, index) of lawsnum"
                    :key="index">
                <span class="c-ti">{{ item.title }}:</span>
                {{ item.count }}
              </span>
            </div>
          </div>
          <div class="bro-list">
            <div class="reclaw">
              <div class="title cmt">
                <span>推荐专业</span>
              </div>
              <div class="commonLaw">
                <div v-for="(item, index) in reclaw"
                     :key="'key-law-sort-' + index"
                     @click.stop="toSearch(false, item)"
                     class="recom-item">
                  <a class=""
                     href="javascript:;">
                    {{item.name}}
                  </a>
                </div>
              </div>
            </div>
            <div class="reclaw right-pad">
              <div class="title">
                <span>常用法规</span>
              </div>
              <ul class="clearfix">
                <li v-for="(item,index) of commonLaw"
                    :key="'key-law-sort-' + index"
                    @click.stop="toSearch(true, item)">
                  <a class="law-link"
                     href="javascript:;">
                    {{item.name}}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="title">
          <span>
            法律法规分类
          </span>
        </div>
        <template>
          <div class="item"
               v-for="(item,index) of fleList"
               :key="index"
               @click.stop="goKind(item)">
            <img src="/img/ui/law/lawbook.png" />
            <div class="desc">{{item.title}}</div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import Menu from '@/components/Menu'
import * as lawApi from '../../datas/js/law.js'
import { LAW_INQUIRE } from '../../datas/constants/statistics.js'
export default {
  components: {
    Menu
  },
  data () {
    /**
     * @property {Object} law_sort 法律法规列表
     * @property {String} law_search_content  搜索框值
     * @property {Object} lawsnum 法规数据统计值
     * @property {String} searchText 搜索框值
     * @property {Object} filterCurrent  当前正在使用的筛选条件
     * @property {Array} Reclaw  常用法律法规
     */
    return {
      type: 2,
      reclaw: [],
      commonLaw: [],
      LawSort: [],
      law_search_content: '',
      lawsnum: [],
      searchText: '',
      filterCurrent: {
        effect_level: '', // 效力级别
        searchText: '', // 搜索框值
        state: '', // 时效性
        area_code: '', // 地区
        parentIndex: '', // 所属门类父
        category: '', // 所属门类子
        publish_date: '', // 发文时间
        perform_date: '' // 生效时间
      }
    }
  },
  computed: {
    appInfo () {
      return this.$store.getters['app/getAppInfo']
    },
    forceLevel () {
      return this.$store.getters['lawStore/forceLevel']
    },
    fleList () {
      let list = this.forceLevel.filter(item => {
        return item.value === 1 || item.value === 2 || item.value === 6
      })
      return list
    }
  },
  watch: {
    searchText () {
      this.searchText = this.searchText.replace(' ', '')
    }
  },
  async mounted () {
    this.$store.dispatch('lawStore/getForceLevel')
    this.$root.getStatistics(LAW_INQUIRE)

    if (!this.appInfo.appId) {
      this.getAppInfo()
    } else {
      this.getLawsnum()
      this.getRecPro()
      this.getRecomLaws()
    }
  },
  methods: {
    getAppInfo () {
      this.$store.dispatch('app/getAppInfoBySite').then(res => {
        if (res.success) {
          this.getLawsnum()
          this.getRecPro()
          this.getRecomLaws()
        } else {
          console.log('获取app信息失败')
        }
      }).catch(error => {
        console.log('[ catch an error ]', error)
      })
    },
    /**
     * @description getLawsnum 获取法律法规统计数据
     * @description getLawSort 获取法律列表
     */
    async getLawsnum () {
      lawApi.getCount().then(res => {
        if (res.response.success) {
          let list = (res.data || []).filter(item => item.title !== '未知')
          let tmpTitleArr = ['总数', '法律', '行政法规', '部门规章', '司法解释', '地方性法规', '地方政府规章', '条约或约定', '自治条例、单行条例', '其他规范性文件', '未知']
          this.lawsnum = list.sort((a, b) => {
            return tmpTitleArr.indexOf(a.title) - tmpTitleArr.indexOf(b.title)
          })
        } else {
          console.log('[ got an error response ]', res.response.msg)
        }
      }).catch(error => {
        console.log('[ catch an error ]', error)
      })
    },
    getRecPro () {
      lawApi.recomPro({ type: 2 }).then(res => {
        if (res.response.success && res.data) {
          let list = res.data || []
          this.reclaw = list.filter(item => {
            return item.name.search(/(空)/g) === -1 && item.name.search(/(移动)/g) === -1
          })
        } else {
          console.log('[ got an error response ]', res.response.msg)
        }
      }).catch(error => {
        console.log('[ catch an error ]', error)
      })
    },
    getRecomLaws () {
      lawApi.getRecomLaws().then(res => {
        if (res.response.success && res.data) {
          this.commonLaw = res.data || []
        } else {
          console.log('[ got an error response ]', res.response.msg)
        }
      }).catch(error => {
        console.log('[ catch an error ]', error)
      })
    },
    goKind (item) {
      switch (+item.value) {
        case 1:
          this.$router.push({
            path: '/lawlist',
            query: { type: item.value }
          })
          return
        case 2:
          this.$router.push({
            path: '/lawsearch',
            query: { title: '行政法规', forceLevel: item.value }
          })
          return
        case 6:
          this.$router.push({
            path: '/lawsearch',
            query: { title: '地方性法规', forceLevel: item.value }
          })
          return
      }
    },
    getSearchResult () {
      // this.filterCurrent.searchText = this.searchText
      const keywords = this.searchText
      this.$router.push({
        path: `/LawSearch?title=搜索结果&keywords=${keywords}`
      })
    },
    toSearch (pro = false, item = {}) {
      if (pro) {
        this.$router.push(`/LawDetail/${item.id}`)
      } else {
        this.$router.push({
          path: `/LawSearch?title=搜索结果&professionalId=${item.id}`
        })
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.main
  padding 0.3rem 0.5rem 0.4rem 0.5rem
  display flex
  justify-content space-between
  .left
    flex 1
    height 100%
    display flex
    flex-direction column
    box-sizing border-box
    .tab-nav
      display flex
      width 5.56rem
      justify-content space-between
      height 0.72rem
      padding 0
      div
        width 2.76rem
        height 100%
        text-align center
        line-height 0.72rem
        color #fff
        font-size 0.28rem
        background-color rgba(255, 255, 255, 0.1)
        border-radius 0.3rem 0.3rem 0px 0px
        &.active
          background #fff
          color #225acc
    .maincon
      position relative
      margin 0
      padding 0
      height 100%
      background-color #fff
      border-radius 0.08rem
      box-sizing border-box
      padding 0.6rem 0.7rem 0.26rem 0.7rem
      overflow-x hidden
      overflow-y scroll
      .voice-small
        position absolute
        left 50%
        transform translateY(-50%)
        bottom -0.35rem
        z-index 2
        .icon
          margin 0.15rem auto
          width 1rem
          height 1rem
          border-radius 50%
          background #30c036 url('/img/common/voice_38.png') center no-repeat
          box-shadow 0px 0.05rem 0.18rem 0px rgba(0, 42, 2, 0.35)
        span
          font-size 0.24rem
          color #999
      .voice-consult
        text-align center
        padding-top 0.2rem
        .voice
          width 1.92rem
          height 1.92rem
          border-radius 50%
          margin 0 auto
          background #30c036 url('/img/common/voice_74.png') center no-repeat
          box-shadow 0px 0.05rem 0.18rem 0px rgba(48, 192, 54, 0.5)
        .title
          font-size 0.36rem
          color #333
          padding 0.3rem 0 0.2rem 0
        .desc
          font-size 0.3rem
          color #666
      .search-input
        text-align center
        .title
          line-height 0.48rem
          padding-bottom 0.5rem
          font-size 0.48rem
          color #333
        .search-box
          display flex
          width 10.8rem
          overflow hidden
          height 0.9rem
          margin 0 auto 0.4rem auto
          box-sizing border-box
          border-radius 0.1rem
          border 2px solid #2f5ccd
          input
            flex 1
            display block
            padding 0 0.3rem
            font-size 0.32rem
            border 0
            background #fff
            color #666
          button
            text-align center
            font-size 0.36rem
            color #fff
            border 0
            background #2f5ccd
            width 2.32rem
        .ht-info
          font-size 0.28rem
          color #333
          line-height 1.5
          display flex
          align-items center
          justify-content center
          flex-wrap wrap
          span
            color #2f5ccd
            margin-left 0.12rem
            &:first-child
              margin 0
            .c-ti
              color #333
    .bro-list
      display flex
      .reclaw
        text-align center
        flex-shrink 0
        width 50%
        overflow hidden
        .title
          position relative
          font-size 0.3rem
          color #333
          text-align center
          margin 0.5rem 0 0.3rem 0
          span
            position relative
            z-index 2
            padding 0 0.3rem
            background #fff
          &:before
            content ''
            width 100%
            height 1px
            position absolute
            top 50%
            left 0
            background #e5e5e5
        .cmt
          margin-right 0.3rem
        ul
          clear both
          li
            margin 0.08rem
            line-height 0.7rem
            font-size 0.28rem
            color #333
            height 0.7rem
            text-align center
            background-color #e1e2e6
            border-radius 0.1rem
          li
            .law-link
              display block
              overflow hidden
              white-space nowrap
              text-overflow ellipsis
            a
              color #333
        .commonLaw
          width 100%
          border-right 1px solid #e5e5e5
          padding-right 0.2rem
          display flex
          flex-wrap wrap
          align-items center
          justify-content space-around
          .recom-item
            width 40%
            overflow hidden
            margin 0.08rem
            line-height 0.7rem
            font-size 0.28rem
            color #333
            height 0.7rem
            text-align center
            background-color #e1e2e6
            border-radius 0.1rem
            white-space nowrap
            text-overflow ellipsis
            a
              color #333
      .right-pad
        padding-left 0.2rem
  .right
    width 3.27rem
    margin-left 0.2rem
    height 100%
    box-sizing border-box
    background-color rgba(255, 255, 255, 0.2)
    border-radius 0.08rem
    border solid 1px rgba(255, 255, 255, 0.2)
    padding 0.4rem 0.35rem
    text-align center
    .title
      font-size 0.28rem
      margin-bottom 0.54rem
      color #fff
      span
        position relative
        padding 0 0.15rem
        &:before, &:after
          content ''
          position absolute
          top 50%
          margin-top -1px
          width 0.2rem
          height 2px
          background rgba(255, 255, 255, 0.1)
        &:before
          left -0.2rem
        &:after
          right -0.2rem
    .item
      display block
      img
        width 1.01rem
        height 1.22rem
        object-fit cover
        margin-bottom 0.3rem
      .desc
        font-size 0.3rem
        color #fff
        margin-bottom 0.65rem
</style>
